import { match } from "react-router-dom";
import IntegrationPublishModuleSubtabWithValidatorV2 from "./IntegrationPublishModuleSubtabWithValidatorV2";

type Props = { integrationID: string; match: match };

const IntegrationPublishRequestTab = ({ integrationID }: Props) => {
  return <IntegrationPublishModuleSubtabWithValidatorV2 integrationID={integrationID} />;
};

export default IntegrationPublishRequestTab;
